import Field from './Field';
import Utils from "../Services/Utils";

class FieldList {
  constructor(item = {}) {
    this.order = item.order || [];
    this.items = item.items || {};
  }

  static parse = async (sectionId, fields, fieldsIdLabelDict, fieldsIdOptionsDict, disabled, chargeCodes) => {
    const order = fields.order || [];
    const items = {};
    const fieldItems = (!Utils.isNull(fields) && !Utils.isNull(fields.items)) ? Object.values(fields.items) : fields;
    if (!order.length) {
      for (const field of fieldItems) {
        order.push(field.id);
        items[field.id] = await Field.parse(sectionId, field, fieldsIdLabelDict, fieldsIdOptionsDict, disabled, chargeCodes);
      }
    }
    else {
      for (const fieldId of order) {
        items[fieldId] = await Field.parse(sectionId, fields.items[fieldId], fieldsIdLabelDict, fieldsIdOptionsDict, disabled, chargeCodes);
      }
    }
    return new FieldList({
        order: order,
        items: items,
      },
    );
  };

  serialize = (sectionLabel, builder) => {
    const arr = [];
    for (const [index, item] of this.order.entries()) {
      this.items[item].changeValue('index', index);
      arr.push(this.items[item].serialize(sectionLabel, builder));
    }
    return arr;
  };

  serializeAsync = async (sectionLabel, builder) => {
    const arr = [];
    for (const [index, item] of this.order.entries()) {
      this.items[item].changeValue('index', index);
      arr.push(await this.items[item].serializeAsync(sectionLabel, builder));
    }
    return arr;
  };

  removeField(index) {
    const fieldName = this.order.splice(index, 1)[0];
    const item = this.items[fieldName];
    delete this.items[fieldName];
    return item;
  }

  addField(index, item, section) {
    item.changeValue('section', section);
    this.items[item.id] = item;
    this.order.splice(index, 0, item.id);
  }

}

export default FieldList;
